import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-icon-checked-circle',
    imports: [],
    templateUrl: './icon-checked-circle.component.html',
})
export class IconCheckedCircle {
    @Input() color: string = '#171717';
    @Input() size: string = '24px';
}